<app-medigi-home *ngIf="isMedigi"></app-medigi-home>
<app-outsourcing-home *ngIf="isOutsourcing"></app-outsourcing-home>
<app-medshorts-home *ngIf="isMedshorts"></app-medshorts-home>
<app-seller-direct *ngIf="isSellerDirect"></app-seller-direct>
